export const prettyJsonStringify = (object: Object) =>
  JSON.stringify(object, null, 2);
